import { divisionsOfWarehouses } from '../../filters/procurementFilters';

/**
 * The divisions the board shows when the buyer has not picked any — derived,
 * never written to the URL, because the URL's divisions are the filters shared
 * with the forecast screens and a default is not a filter the buyer chose.
 *
 * In order: the divisions of a shared branch filter (the forecast can filter to
 * a branch without naming one; this board cannot), then the buyer's saved
 * last-used divisions, then just the first division — never every division,
 * which on a Rexel-scale org hits tier-1 across ~25k pending suggestions on
 * page open. Empty while an input it needs is still loading, so the board does
 * not flash one division and then jump to another.
 */
export function defaultDivisionIds({
  divisions,
  urlWarehouseIds,
  warehouses,
  savedDivisionIds,
  savedPending,
}: {
  divisions: { id: string }[];
  urlWarehouseIds: string[];
  /** Undefined while the warehouse list loads. */
  warehouses: { id: string; division?: { id: string } | null }[] | undefined;
  savedDivisionIds: string[];
  /** The saved-preference query has no definitive answer yet. */
  savedPending: boolean;
}): string[] {
  if (divisions.length === 0) return [];
  if (urlWarehouseIds.length > 0) {
    if (!warehouses) return [];
    const derived = divisionsOfWarehouses(
      urlWarehouseIds,
      warehouses,
      divisions,
    );
    if (derived.length > 0) return derived;
  }
  if (savedPending) return [];
  const offered = new Set(divisions.map((d) => d.id));
  const validSaved = savedDivisionIds.filter((id) => offered.has(id));
  if (validSaved.length > 0) return validSaved;
  return [divisions[0].id];
}
